import * as React from 'react';
import proptypes from 'prop-types';
const {
  shape,
  bool
} = proptypes;
export const AppError = _ref => {
  let {
    error = null,
    debug = false
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    id: "root__error",
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid isBound"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col__12-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid error-page",
    "data-testid": "errorContent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid isBound error-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sui-flex sui-flex-col sui-justify-center sui-items-center -sui-ml-3 -sui-mt-3 sui-pt-96 col__12-12"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://assets.homedepot-static.com/images/v1/oops.svg",
    alt: "",
    className: "stretchy sui-max-w-2xl",
    width: "702",
    height: "205"
  }), /*#__PURE__*/React.createElement("h1", {
    className: "error-page__title u__display-font--black"
  }, "WE'RE FIXING IT."), /*#__PURE__*/React.createElement("div", {
    className: "error-page__description"
  }, /*#__PURE__*/React.createElement("p", null, "We'll have this patched up as soon as possible.")), error && debug && /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", null, error.toString())), error && debug && /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", null, error.stack)), /*#__PURE__*/React.createElement("div", {
    className: "sui-mb-3"
  }, /*#__PURE__*/React.createElement("a", {
    className: "bttn bttn--primary bttn--inline u__bottom--standard body__m-right-large",
    href: "/"
  }, /*#__PURE__*/React.createElement("span", {
    className: "bttn__content"
  }, "Back to homepage")))))))));
};
AppError.propTypes = {
  error: shape({}),
  debug: bool
};
//# sourceMappingURL=AppError.js.map